"use client"

import React from "react"
import { Helmet } from "react-helmet-async"
import { useState } from "react"
import { MapPin, Phone, Mail, Globe, Clock, Send, MessageCircle, GraduationCap } from "lucide-react"
import EnquiryForm from "../components/EnquiryForm"
import { Button } from "@mui/material"
import { BiLocationPlus } from "react-icons/bi"
import { FaMapLocation } from "react-icons/fa6"

export default function ContactPage() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        category: "",
        course: "",
        message: "",
    })

    const handleSubmit = (e) => {
        e.preventDefault()
        console.log("Form submitted:", formData)
        // Handle form submission here
    }



    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-10 via-white to-blue-50">
            <Helmet>
                <title>Contact SSS Achievers | Coaching Institute in Ghazipur UP</title>
                <meta name="description" content="Contact SSS Achievers at 96/B, Badi Bagh, Ghazipur UP 233001. Call +91 99185 19991. Visit Ghazipur's best coaching center for Class 8-12. Mon-Sat 9AM-6PM." />
                <link rel="canonical" href="https://www.sssachievers.com/contact" />
                <meta property="og:title" content="Contact SSS Achievers | Coaching Institute in Ghazipur" />
                <meta property="og:description" content="Visit SSS Achievers at 96/B, Badi Bagh, Ghazipur UP. Call +91 99185 19991. Ghazipur's best coaching center for Class 8-12." />
                <meta property="og:url" content="https://www.sssachievers.com/contact" />
            </Helmet>
            {/* Header Section */}
            <div className="text-center mb-16 py-5">
                <div className="inline-flex items-center gap-2 bg-[#0097b2]/10 px-4 py-2 rounded-full mb-6">
                    <GraduationCap className="h-5 w-5 text-[#0097b2]" />
                    <span className="text-[#0097b2] font-semibold">Get in Touch</span>
                </div>
                <h1 className="text-2xl md:text-6xl font-bold text-gray-900 mb-6">
                    Contact <span className="text-[#0097b2]">SSS Achievers</span>
                    {/* <span className="block  mt-2">Your Path to Success</span> */}
                </h1>
                <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
                    Reach out to SSS Achievers, Ghazipur's premier coaching center for 9th to 12th students and competitive exam aspirants. We're here to answer your questions about our programs, faculty, or facilities.
                </p>
            </div>

            {/* Main Content */}
            <div className="container mx-auto px-4 py-8 -mt-8 relative z-10">
                <div className="flex flex-col lg:flex-row justify-around max-w-7xl mx-auto space-y-8 lg:space-y-0">
                    {/* Contact Information divs */}
                    <div className="lg:col-span-1 space-y-6">
                        {/* Location div */}
                        <div className="border-0 h-auto lg:h-44 flex content-center items-center shadow-lg hover:shadow-xl transition-all duration-300 bg-white/80 backdrop-blur-sm">
                            <div className="p-6">
                                <div className="flex items-start space-x-4">
                                    <div className="bg-[#0097b2] p-3 rounded-full">
                                        <MapPin className="h-6 w-6 text-white" />
                                    </div>
                                    <div className="flex-1">
                                        <h3 className="text-xl font-bold text-gray-900 mb-2">Our Location</h3>
                                        <p className="text-gray-600 leading-relaxed">
                                            96/B, Badi Bagh, Opp Raj Nursing Homes, Ghazipur, Uttar Pradesh 233001
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Contact Information div */}
                        <div className="border-0 h-auto lg:h-44 flex content-center items-center shadow-md hover:shadow-xl transition-all duration-300 bg-white/80 backdrop-blur-sm">
                            <div className="p-6">
                                <div className="flex items-start space-x-4">
                                    <div className="bg-[#0097b2] p-3 rounded-full">
                                        <Phone className="h-6 w-6 text-white" />
                                    </div>
                                    <div className="flex-1">
                                        <h3 className="text-xl font-bold text-gray-900 mb-4">Contact Information</h3>
                                        <div className="space-y-3">
                                            <div className="flex items-center space-x-3">
                                                <Phone className="h-4 w-4 text-[#0097b2]" />
                                                <span className="text-gray-600">+91 99185 19991</span>
                                            </div>
                                            <div className="flex items-center space-x-3">
                                                <Mail className="h-4 w-4 text-[#0097b2]" />
                                                <span className="text-gray-600">info@sssachievers.com</span>
                                            </div>
                                            <div className="flex items-center space-x-3">
                                                <Globe className="h-4 w-4 text-[#0097b2]" />
                                                <span className="text-gray-600">www.sssachievers.com</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Office Hours div */}
                        <div className="border-0 h-auto lg:h-44 flex content-center items-center shadow-lg hover:shadow-xl transition-all duration-300 bg-white/80 backdrop-blur-sm">
                            <div className="p-6">
                                <div className="flex items-start space-x-4">
                                    <div className="bg-[#0097b2] p-3 rounded-full">
                                        <Clock className="h-6 w-6 text-white" />
                                    </div>
                                    <div className="flex-1">
                                        <h3 className="text-xl font-bold text-gray-900 mb-4">Office Hours</h3>
                                        <div className="space-y-2">
                                            <div className="flex justify-between items-center">
                                                <span className="text-gray-600">Monday - Saturday</span>
                                                <span className="font-medium text-[#0097b2]">9:00 AM - 6:00 PM</span>
                                            </div>
                                            <div className="flex justify-between items-center">
                                                <span className="text-gray-600">Sunday</span>
                                                <span className="font-medium text-red-500">Closed</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Contact Form */}
                    <div className="w-full lg:w-auto">
                        <EnquiryForm />
                    </div>
                </div>
            </div>
        </div>
    )
}
